import React, { useCallback, useContext, useEffect } from 'react';
import { Box, Divider, IconButton, Typography  } from '@mui/material';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { Context} from '../../store/Context';


const OrderCard = ({
    order, 
    remove 
}) => {   
    const { contextState: {         
        currencyIcon
    } } = useContext( Context ); 
    return (
        <Grid item xs={12} md={12}>           
            <Card sx={{ display: 'flex'}}>               
                <CardMedia
                    component="img"
                    sx={{ width: 60, height: 80, display: { xs: 'none', sm: 'block' } }}
                    image={order.img}
                    alt={order.name}
                />   
                <CardContent sx={{ flex: 1, position: 'relative' }}>
                    <Grid container direction="row" justifyContent="flex-end" spacing={1}>
                        <Grid item xs={9}>
                            <Typography component="h5" variant="h5" color="black" style={{ fontSize: 16, fontWeight: 600 }}>
                                {order.name}
                            </Typography>                            
                            <Typography variant="h5" color="blue" style={{fontSize: 14}}>
                                {currencyIcon} {order.price}
                            </Typography> 
                        </Grid>
                        <Grid item xs={3}>                                
                                <IconButton
                                    size="large"
                                    aria-label={``}
                                    color="inherit"
                                    aria-describedby={`remove-item-${order.id}`} 
                                    onClick={() => remove(order.orderID)}
                                >                          
                                    <HighlightOffIcon />                            
                                </IconButton>
                            
                        </Grid>
                    </Grid>                   
                </CardContent>       
               
            </Card>           
        </Grid>
    );
}

function OrderSummary({ 
    state,
    remove 
}) {

    const { orders, currencyIcon, pagination} = state;     

    /***
     *  Pagination
     * */
    const { itemsPerPage } = pagination;
    const [page, setPage] = React.useState(0);
    const [items, setItems] = React.useState([]);
    const [totalPages, setTotalPages] = React.useState(0);
    const [showPaginationBar, setShowPaginationBar] = React.useState(false);

    const handleChange = (event, value) => setPage(value, event);

    /***
     * Calculate Pagination 
     **/
    const paginateItems = useCallback( () => {     

        // page value needs to be at least 1
        let _page = 0;;
        (page === 0) ? _page = 1: _page = page;  

        // Define items to be displayed
        const 
            startPos = ((_page - 1) * itemsPerPage),
            totalPages = Math.ceil( orders.length / itemsPerPage ),
            items = [...orders].splice( startPos, itemsPerPage);                      

        const showBar = (orders.length > itemsPerPage);        

         // update local state
        setTotalPages( totalPages );         
        setItems( items );
        setShowPaginationBar(showBar);

        // Test if page is out of range       
        if( _page > totalPages) {         
            setPage(totalPages);
        }
    }, [
        page, 
        orders,
        itemsPerPage,
        setItems,    
        setPage
    ]);

    /***
     * Show Pagination Bar
     */
    const configureAtPageLoad = useCallback( () => {
        if(orders.length > itemsPerPage)
            setShowPaginationBar(true);
    }, [
        orders,
        itemsPerPage,
        setShowPaginationBar
    ]);

    /***
     * Trigger Pagination
     */
    useEffect( () => {
        setPage(1);  
        configureAtPageLoad();        
    }, [
        configureAtPageLoad
    ]);    

    /***
     *  Monitor Orders
     */
    useEffect( () => {           
        paginateItems();        
    }, [
        orders,     
        paginateItems
    ]);      
    
	return (
        <Box>                    
            <Divider variant="fullwidth" sx={{ mt:2, mb:2, background: '#1976d2'}}>
                <Typography component="h5" color="white" style={{ fontWeight: 400, padding: 4 }}>
                    Order Summary
                </Typography>                  
            </Divider>   
            <Grid container spacing={1} sx={{mt: 1}}>
                {items.map( (item, i) => {                       
                    return (<OrderCard 
                        key={i} 
                        order={item}                                                 
                        currencyIcon={currencyIcon} 
                        remove={remove}
                    />);
                })}
            </Grid> 
            {showPaginationBar && <Stack spacing={2}>
                <Typography>Page: {page}</Typography>
                <Pagination count={totalPages} page={page} onChange={handleChange} />
            </Stack>}         
        </Box>
    );
}

export default OrderSummary;